export const nature = [
  { char: '☀️', name: 'Sun', nameZh: '太陽', keywords: ['weather', 'hot', '晴天'] },
  { char: '🌙', name: 'Moon', nameZh: '月亮', keywords: ['night', 'sleep', '浪漫'] },
  { char: '✨', name: 'Sparkles', nameZh: '閃爍', keywords: ['magic', 'shine', '質感'] },
  { char: '🌊', name: 'Wave', nameZh: '海浪', keywords: ['sea', 'summer', '衝浪'] },
  { char: '🔥', name: 'Fire', nameZh: '火', keywords: ['hot', 'trend', '熱門'] },
  { char: '🌈', name: 'Rainbow', nameZh: '彩虹', keywords: ['color', 'happy', '希望'] },
  { char: '🌸', name: 'Cherry Blossom', nameZh: '櫻花', keywords: ['flower', 'pink', '春天'] },
  { char: '🍀', name: 'Four Leaf Clover', nameZh: '幸運草', keywords: ['luck', 'green', '好運'] },
  { char: '🌱', name: 'Seedling', nameZh: '幼苗', keywords: ['grow', 'plant', '開始'] },
  { char: '🌿', name: 'Herb', nameZh: '草本', keywords: ['nature', 'green', '放鬆'] },
  { char: '🍂', name: 'Fallen Leaf', nameZh: '落葉', keywords: ['fall', 'autumn', '思念'] },
  { char: '🍄', name: 'Mushroom', nameZh: '蘑菇', keywords: ['nature', 'cute', '森林'] },
  { char: '🪷', name: 'Lotus', nameZh: '蓮花', keywords: ['flower', 'zen', '瑜珈', '純淨'] },
  { char: '🪸', name: 'Coral', nameZh: '珊瑚', keywords: ['sea', 'ocean', 'nature', '海洋'] },
  { char: '🪹', name: 'Empty Nest', nameZh: '空巢', keywords: ['home', 'wait', '等待'] },
  { char: '🪺', name: 'Nest with Eggs', nameZh: '鳥巢', keywords: ['home', 'life', '出生'] },
  { char: '🐦‍🔥', name: 'Phoenix', nameZh: '浴火重生', keywords: ['myth', 'bird', 'rebirth', '重生', '傳奇'] },
  { char: '🪵', name: 'Wood', nameZh: '質感原木', keywords: ['nature', 'winter', 'dead', '寂靜', '基礎'] },
  { char: '🫛', name: 'Pea Pod', nameZh: '豌豆', keywords: ['food', 'green', 'healthy'] },
];